import React from 'react';
import { useAppSelector } from 'app/hooks';
import classNames from 'classnames';
import { Button } from '@tcc/crate';
import { workPlanStates } from 'constants/affiliates';
import johnDeereLogo from '../../images/john-deere-logo.png';
import { dateFormatter } from '@tcc/i18n';
import { getMessage } from 'util/locale';

const baseString = 'jd-work-plan';

const JohnDeereWorkPlan = ({ scriptId, isSelected }: { scriptId: string; isSelected: boolean }) => {
  const workPlan = useAppSelector((state) => state.affiliates.deere?.workPlans?.byScriptId?.[scriptId]);

  if (!workPlan) {
    return null;
  }

  const classString = classNames({
    [`${baseString}`]: true,
    isSelected: isSelected
  });

  const formattedDate = dateFormatter(workPlan.createdAt, {
    hour: 'numeric',
    minute: 'numeric'
  });

  return (
    <section className={classString}>
      <img src={johnDeereLogo} alt='John Deere' />
      <div>
        <Button
          data-test-id='work-plan-button'
          disabled={workPlan.state !== workPlanStates.COMPLETE}
          mode='primary'
          onClick={() => window.open(workPlan.url)}
        >
          {getMessage('button-text__view-JD-work-plan')}
        </Button>
        <p>{getMessage('john-deere-ops-center')}</p>
        <p>
          {getMessage('last-sent')}
          <time>{` ${formattedDate}`}</time>
        </p>
      </div>
    </section>
  );
};

export default JohnDeereWorkPlan;
